import { type RouteComponentProps, withRouter } from 'react-router'
import { noop } from 'lodash'
import { parseISO, isPast } from 'date-fns'
import type { ColumnProps } from 'antd/lib/table'

import { formatDatetime } from '~/utils'
import { withScheme } from '~/components/Scheme'
import Table from '~/components/Table'
import * as routes from '~/constants/routes'

import { SCHEME } from '~/types'
import {
  useUserAddonListQuery,
  type UserAddonListQuery_user_User_table_UserAddonConnection_nodes_UserAddon as UserAddonListItem,
} from '~/gql/generated/graphql'
import { defaultData } from './data'

const isInactive = (userAddon: UserAddonListItem): boolean => {
  const dt = parseISO(userAddon.valid_until)
  return isPast(dt)
}

const columns: ColumnProps<UserAddonListItem>[] = [
  {
    title: 'ID',
    dataIndex: 'id',
  },
  {
    title: 'Date/Time',
    dataIndex: 'created_at',
    render: text => formatDatetime(text),
  },
  {
    title: 'Name',
    dataIndex: ['scheme_addon', 'name'],
  },
  {
    title: 'Valid Until',
    dataIndex: 'valid_until',
    render: text => formatDatetime(text),
  },
]

const UserAddons = ({
  scheme,
  user_id,
  history,
}: {
  scheme: SCHEME
  user_id: string
} & RouteComponentProps) => {
  const variables = {
    scheme_id: scheme.id,
    user_id,
    order_by: [{ id: 'desc' }],
  }
  const { data, loading } = useUserAddonListQuery({
    variables,
    errorPolicy: 'all',
  })

  // If it loads defaultData then that won't be null!
  const tableData = (data?.user ??
    defaultData.user) as (typeof defaultData)['user']

  return (
    <Table<UserAddonListItem>
      columns={columns}
      data={tableData}
      loading={loading}
      onChange={noop}
      rowClassName={(record: UserAddonListItem) =>
        isInactive(record) ? 'inactive-row' : 'generic'
      }
      onRow={(record: UserAddonListItem) => {
        return {
          onClick: () => {
            history.push(
              routes.prependScheme(
                `${routes.ADDONS}/${record.scheme_addon.id}`,
                record.scheme_addon.scheme_id,
              ),
            )
          },
        }
      }}
    />
  )
}

export default withRouter(withScheme(UserAddons))
